import React from 'react';
import { useTheme } from '../../../../theme-context';

interface RangeSliderProps {
    label: string;
    min: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
    label,
    min,
    max,
    value,
    onChange,
}) => {
    const { theme } = useTheme();
    const percent = ((value - min) / (max - min)) * 100;
    const background = theme === 'dark'
        ? `linear-gradient(to right, white ${percent}%, #000 ${percent}%)`
        : `linear-gradient(to right, #1f2937 ${percent}%, #d1d5db ${percent}%)`;

    return (
        <div className='flex flex-col space-y-2 w-full'>
            <label className='font-medium text-gray-700 dark:text-gray-200 mb-2'>{label}</label>
            <div className='flex flex-row items-center'>
                <span className='text-sm font-medium text-gray-800 no-wrap dark:text-primary-dark mr-2'>
                    €{min.toLocaleString()} - €{value.toLocaleString()}
                </span>
                <input
                    type='range'
                    min={min}
                    max={max}
                    value={value}
                    onChange={(e) => onChange(+e.target.value)}
                    className={`${theme === 'dark' ? 'range-slider-dark' : 'range-slider'} w-[50%] max-w-[50%]`}
                    style={{
                        background: background
                    }}
                />
            </div>
        </div>
    );
};

export default RangeSlider;
